import { State, Action, StateContext, Actions, ofActionSuccessful } from '@ngxs/store';
import { StoreState, StoreInfoUser, StoreToken, GetInfoUser, OpenOTP, SetDataOTP, SetTimeOTP, StoreTheme, StoreSourceInfos, GetIssuers, GetProducts, StoreResource, StoreThirdAppId, StorePermission } from './app.actions';
import { Injectable } from '@angular/core';
import { Dispatcher } from './base/dispatcher';
import { UserService } from '../common/service/user.service';
import { UserProfile } from '../common/models/users.model';
import { AuthorizeService } from '../main/services/authorize.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NewOTPComponent } from '../common/components/otp/otp.component';
import { LocalStorageService } from 'ngx-webstorage';
import { EventManagerService } from '../common/service/event-manager.service';
import { AgentService } from '../main/agent/agent.service';
declare let $: any;
export interface AppStateModel {
    states: any;
    userProfile: any;
    foPermission: any;
    token: string;
    theme: any;
    sourceInfos: any;
    thirdAppIds: any;
    resources: any;
    otp: any;
    issuers: any;
    products: any;
}

export function initAppState(): AppStateModel {
    return {
        userProfile: new UserProfile(),
        states: [],
        issuers: [],
        products: [],
        resources: {}
    } as AppStateModel;
}

@State<AppStateModel>({
    name: 'App',
    defaults: initAppState()
})
@Injectable()
export class AppState {

    constructor(
        private actions$: Actions,
        private dispatcher: Dispatcher,
        private userService: UserService,
        private modalService: NgbModal,
        private localStorage$: LocalStorageService,
        public eventManger: EventManagerService,
        private authorService: AuthorizeService,
        private agentService: AgentService
    ) { }

    @Action(StoreState)
    StoreTag(ctx: StateContext<AppStateModel>, action: StoreState) {
        const states = action.payload;
        ctx.patchState({
            states
        });
    }
    @Action(StoreToken)
    StoreToken(ctx: StateContext<AppStateModel>, action: StoreToken) {
        const token = action.payload;
        ctx.patchState({
            token
        });
    }
    @Action(StorePermission)
    StorePermission(ctx: StateContext<AppStateModel>, action: StoreToken) {
        const foPermission = action.payload;
        ctx.patchState({
            foPermission
        });
    }
    @Action(StoreTheme)
    StoreTheme(ctx: StateContext<AppStateModel>, action: StoreTheme) {
        const theme = action.payload;
        ctx.patchState({
            theme
        });
    }
    @Action(StoreSourceInfos)
    StoreSourceInfos(ctx: StateContext<AppStateModel>, action: StoreSourceInfos) {
        const sourceInfos = action.payload;
        ctx.patchState({
            sourceInfos
        });
    }
    @Action(StoreThirdAppId)
    StoreThirdAppIds(ctx: StateContext<AppStateModel>, action: StoreThirdAppId) {
        const thirdAppIds = action.payload;
        ctx.patchState({
            thirdAppIds
        });
    }
    @Action(StoreResource)
    StoreResource(ctx: StateContext<AppStateModel>, action: StoreResource) {
        const resources = action.payload;
        (resources.phonePostalCodes || []).forEach((item, index) => {
            item.id = index;
            item.name = item.countryCode + ' (+' + item.callingCode + ')';
        });
        ctx.patchState({
            resources
        });
    }
    @Action(StoreInfoUser)
    StoreInfoUser(ctx: StateContext<AppStateModel>, action: StoreInfoUser) {
        const userProfile = action.payload;
        this.authorService.setAuthoritiesForUser(userProfile);
        ctx.patchState({
            userProfile
        });
    }
    @Action(GetInfoUser)
    GetInfoUser(ctx: StateContext<AppStateModel>, action: GetInfoUser) {
        return this.userService.getProfileAPI(true);
    }
    @Action(OpenOTP)
    OpenOTP(ctx: StateContext<AppStateModel>, action: OpenOTP) {
        const otp = Object.assign({}, ctx.getState().otp || {});
        const payload = Object.assign({}, action.payload || {});
        const user = this.localStorage$.retrieve('USER_PROFILE') || {};
        const options: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false
        };
        options.centered = true;
        options.windowClass = 'otp-order-label';
        const modalRef = this.modalService.open(NewOTPComponent, options);
        const properties = payload.isReopen ? otp : payload;
        modalRef.componentInstance.phone = payload.phone || user.phone;
        Object.keys(properties || {}).forEach((key) => {
            modalRef.componentInstance[key] = properties[key] || {};
        });
        if (!payload.isReopen) {
            Object.keys(properties || {}).forEach((key) => {
                otp[key] = properties[key] || {};
            });
            otp.startTime = Date.now();
            otp.failTimes = 0;
            modalRef.componentInstance.startTime = otp.startTime;
        }
        ctx.patchState({
            otp
        });
    }
    @Action(SetTimeOTP)
    SetTimeOTP(ctx: StateContext<AppStateModel>, action: SetTimeOTP) {
        const otp = Object.assign({}, ctx.getState().otp || {});
        const time = action.payload;
        otp.startTime = time;
        ctx.patchState({
            otp
        });
    }
    @Action(SetDataOTP)
    SetDataOTP(ctx: StateContext<AppStateModel>, action: SetDataOTP) {
        const otp = Object.assign({}, ctx.getState().otp || {});
        const payload = action.payload;
        Object.keys(payload).forEach((key) => {
            otp[key] = payload[key];
        });
        this.eventManger.broadcast({
            name: 'set-data-otp',
            content: {
                data: Object.assign({}, otp.data || {}),
                func: otp.func
            }
        })
        ctx.patchState({
            otp
        });
    }
    @Action(GetIssuers)
    GetIssuers(ctx: StateContext<AppStateModel>, action: GetIssuers) {
        let body = {
            page: 1,
            pageSize: 1000
        };
        const issuers = Object.assign({}, ctx.getState().issuers || {});
        if (issuers.length) {
            return;
        }
        return this.agentService.getIssuers(body)
            .subscribe((res: any) => {
                const issuers = res.data.rows || [];
                ctx.patchState({
                    issuers
                });
            });
    }
    @Action(GetProducts)
    GetProducts(ctx: StateContext<AppStateModel>, action: GetProducts) {
        const payload = action.payload;
        let body = {
            page: 1,
            pageSize: 250,
            types: payload
        };
        const products = Object.assign({}, ctx.getState().products || {});
        if (products.length) {
            return;
        }
        return this.agentService.getProducts(body)
            .subscribe((res: any) => {
                const products = (res.data.rows || []).map((item) => {
                    item.showName = item.subCode ? item.code + '/' + item.subCode : item.code;
                    return item;
                });
                ctx.patchState({
                    products
                });
            });
    }
}
